
import axios from 'axios';
import { toast } from 'react-toastify';
import { API_URL } from '../config'; // adjust path as needed

// ✅ Axios instance with base settings
const api = axios.create({
  baseURL: API_URL, // ✅ Now it uses the dynamic value
  withCredentials: true,
});


// ✅ Attach auth headers automatically
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

// ✅ Centralized GET with array validation
export const getArray = async (url, label = 'Data') => {
  try {
    const res = await api.get(url);
    if (Array.isArray(res.data)) {
      return res.data;
    } else {
      toast.error(`Unexpected ${label} format`);
      console.error(`❌ ${label} response is not an array:`, res.data);
      return [];
    }
  } catch (err) {
    console.error(`❌ Error fetching ${label}:`, err);
    toast.error(`Failed to load ${label}`);
    return [];
  }
};

// ✅ Standard GET (for single object)
export const get = async (url, label = 'Data') => {
  try {
    const res = await api.get(url);
    return res.data;
  } catch (err) {
    console.error(`❌ Error fetching ${label}:`, err);
    toast.error(`Failed to load ${label}`);
    throw err;
  }
};

// ✅ Standard POST
export const post = async (url, data, label = 'Action') => {
  try {
    const res = await api.post(url, data);
    toast.success(`${label} succeeded`);
    return res.data;
  } catch (err) {
    console.error(`❌ ${label} failed:`, err);
    toast.error(`${label} failed`);
    throw err;
  }
};

// ✅ PUT, DELETE etc. can be added the same way
